import SectionCell from './SectionCell';

export default SectionCell;
